import React from "react";
import Helmet from "react-helmet";
import Img from "gatsby-image"
import PostListing from "../components/PostListing/PostListing";
import SEO from "../components/SEO/SEO";
import config from "../../data/SiteConfig";

class Articles extends React.Component {
  render() {
    console.log(this.props);
    const postEdges = this.props.data.articles.edges;
    return (
      <div className="articles-container">
        <Helmet>
          <title>المقالات - {config.siteTitle}</title>
          <link rel="canonical" href={`${config.siteUrl}`} />
        </Helmet>
        <SEO postEdges={postEdges} />
        <PostListing postEdges={postEdges} />
      </div>
    );
  }
}

export default Articles;

/* eslint no-undef: "off"*/
export const pageQuery = graphql`
  query ArticlesQuery {
    articles: allMarkdownRemark(
      limit: 2000
      sort: { fields: [frontmatter___id], order: DESC }
      filter: { fields: { sourceInstanceName: { eq: "articles" } } }
    ) {
      edges {
        node {
          fields {
            slug
            sourceInstanceName 
          }
          excerpt
          timeToRead
          frontmatter {
            title
            tags
            cover {
              childImageSharp {
                sizes(
                  maxWidth: 450
                  quality: 90
                  traceSVG: { color: "#f3f3f3" }
                ) {
                  ...GatsbyImageSharpSizes_withWebp_noBase64
                }
              }
            }
            date
            slug
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/articles.jsx